import { render, staticRenderFns } from "./MyTask.vue?vue&type=template&id=882d15a4&scoped=true&"
import script from "./MyTask.vue?vue&type=script&lang=js&"
export * from "./MyTask.vue?vue&type=script&lang=js&"
import style0 from "./MyTask.vue?vue&type=style&index=0&id=882d15a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882d15a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('882d15a4')) {
      api.createRecord('882d15a4', component.options)
    } else {
      api.reload('882d15a4', component.options)
    }
    module.hot.accept("./MyTask.vue?vue&type=template&id=882d15a4&scoped=true&", function () {
      api.rerender('882d15a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageAgentSub/MyTask.vue"
export default component.exports